import { NewsService } from "./services/NewsService";

const apiUrl = process.env.REACT_APP_API_URL;

export const newsService = new NewsService(apiUrl);
